import BreadCrumb from "components/Common/BreadCrumb";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row } from "reactstrap";
import AllWallets from "./AllWallets";
import Widgets from "./Widgets";
import Widget2s from "./Widget2s";

export default function Wallet() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = `${t("Home")} - ${t("Wallet")}`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Wallet")} pageTitle={t("Home")} />
          {/* <Row>
            <Widget2s />
          </Row> */}
          <AllWallets />
        </Container>
      </div>
    </React.Fragment>
  );
}
